export default (value1, value2) => {
  const date1 = new Date(value1);
  const date2 = new Date(value2);
  if (date1 === date2) return 0;
  else if (date1 > date2) return 1;
  else return -1;
};
